module.exports = __webpack_public_path__ + "img/surveillance_scene.38727781.webp";